var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_ROUTES, DEFAULT_RESULT_SIZE } from 'lib/workperks/common/constants';
import { axios } from "lib/Init";
export default class ESSponsoredKeywordsService {
    _queryObject(query) {
        if (!query || query.length === 0) {
            return { match_all: {} };
        }
        return {
            'term': {
                'name.keyword': {
                    'value': query,
                }
            }
        };
    }
    _buildRequest(query) {
        let queryObject = this._queryObject(query);
        return {
            size: DEFAULT_RESULT_SIZE,
            from: 0,
            _source: true,
            query: {
                bool: {
                    must: [queryObject],
                    "filter": [
                        {
                            "term": {
                                "keywordActive": true
                            }
                        }
                    ]
                },
            },
        };
    }
    search(query) {
        return __awaiter(this, void 0, void 0, function* () {
            query = query && query.length > 0 ? query.toLowerCase() : null;
            let request = this._buildRequest(query);
            // Prod will return 404 if there is an error, don't panic
            // thinking it's the URL...
            return yield axios
                .post(API_ROUTES.elasticsearch.sponsored_keyword, request)
                .then(response => {
                return response.data.hits.hits.map(perk => perk._source);
            })
                .catch(response => {
                console.error("Error-----Res", response);
            });
        });
    }
}
